// Onay akışı tiplerinin TEK doğruluk kaynağı. İki yerde kullanılır:
//   1) Onay Akışları listesi — tip kolonu / filtre / form seçeneği
//   2) Çalışan detayı > Onay Akışları sekmesi — her tip için bir slot satırı
// Sıra ekranda göründüğü sıradır; yeni bir tip eklendiğinde iki ekran da
// kendiliğinden güncellenir.
export const FLOW_TYPES = [
  { id: 'leave', labelKey: 'approvalFlow.leave' },
  { id: 'expense', labelKey: 'approvalFlow.expense' },
  { id: 'certification', labelKey: 'approvalFlow.certification' },
  { id: 'employee-profile', labelKey: 'approvalFlow.employeeProfile' },
  { id: 'goal', labelKey: 'approvalFlow.goal' },
  // ATS teklif onayı — çok seviyeli zincir. Akış, teklifi AÇAN işe alımcıya atanır
  // (izinde ilişkinin talep sahibine bağlanmasıyla aynı deyim); aday bir Flexbee
  // kullanıcısı olmadığı için özne talebi açan kişidir. Atanmamışsa teklif bugünkü
  // tek seviyeli onaya düşer — zincir kurmayan kiracı teklif veremez hâle GELMEZ.
  { id: 'ats-offer', labelKey: 'approvalFlow.atsOffer' },
];

export const FLOW_TYPE_IDS = FLOW_TYPES.map((f) => f.id);

/** `{ id, name }` biçiminde çevrilmiş seçenek listesi (GenericSelect sözleşmesi). */
export const buildFlowTypeOptions = (t) => FLOW_TYPES.map((f) => ({ id: f.id, name: t(f.labelKey) }));
